export type AlarmValue = string | number | null | undefined;

const ALARM_VALUE_FORMATTER = new Intl.NumberFormat('de-AT', {
  maximumSignificantDigits: 6,
});

/**
 * Keeps useful precision for small alarm values without displaying the
 * database Decimal field's trailing zeroes.
 */
export function formatAlarmValue(value: AlarmValue): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  const normalizedValue = typeof value === 'string' ? value.trim() : value;
  if (normalizedValue === '') {
    return '—';
  }

  const numericValue = Number(normalizedValue);

  if (!Number.isFinite(numericValue)) {
    return String(normalizedValue);
  }

  return ALARM_VALUE_FORMATTER.format(
    Object.is(numericValue, -0) ? 0 : numericValue
  );
}
